import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css'
import file from '../../assets/resume.pdf'
import logo from '../../assets/20220729_025450.png'
const Navbar = ({ bgColor, textColor }) => {
    return (
        <div className='main__navbar' style={{ backgroundColor: `${bgColor}`, color: `${textColor}`, position: "fixed", width: "100%", top: "0", zIndex: "100" }} >
            <div className="navbar__width">
                <div >
                    <div className=" navbar__container">
                        <h3 className="logo">
                            <Link to="/">
                                <img src={logo} alt="" />
                            </Link>
                        </h3>
                        <nav className="nav__links">
                            <NavLink className="outline__link" to='/about-me'>About</NavLink>
                            <NavLink style={{ marginLeft: "1rem" }} className="outline__link" to='/blogs'>Blogs</NavLink>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Navbar;